<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="CostCenter"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="FinanceNotificationDetails && FinanceNotificationDetails.length > 0">
    <ssg-tabset (tabChange)="selectTab($event)" class="tabcontainer tabcontentbox">
      <ssg-tab tabTitle="کسور">
        <editable-grid
          *ngIf="isActveTab('کسور') && DeductColumns && DeductColumns.length > 0"
          [columns]="FinanceNotificationDetails"
          [dataList]="DeductColumns"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="تعهدات">
        <editable-grid
          *ngIf="isActveTab('تعهدات') && BossColumns && BossColumns.length > 0"
          [columns]="FinanceNotificationDetails"
          [dataList]="BossColumns"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="کارکرد">
        <editable-grid
          *ngIf="isActveTab('کارکرد') && WorkColumns && WorkColumns.length > 0"
          [columns]="FinanceNotificationDetails"
          [dataList]="WorkColumns"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="سایر">
        <editable-grid
          *ngIf="isActveTab('سایر') && OtherColumns && OtherColumns.length > 0"
          [columns]="FinanceNotificationDetails"
          [dataList]="OtherColumns"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
